import {
  type AccessControlConfig,
  type WarehouseLocationFeature,
  type AccessGatedProps,
  useAccessControl,
  AccessGated,
} from '@retailer-platform/dashboard/access-control'
import { type Permission } from '../../access-control/permissions'
import { type FeatureToggle } from '../../access-control/featureToggles'
import { type FeatureEntitlements } from '../../access-control/featureEntitlements'

export type DomainAccessControlConfig =
  | AccessControlConfig<FeatureToggle, Permission, WarehouseLocationFeature, FeatureEntitlements>
  | AccessControlConfig<FeatureToggle, Permission, WarehouseLocationFeature, FeatureEntitlements>[]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDomainAccessControl = useAccessControl as any as () => (
  accessControlConfig: DomainAccessControlConfig
) => boolean

type DomainAccessControlProps = Omit<AccessGatedProps, 'accessControlConfig'> & {
  accessControlConfig: DomainAccessControlConfig
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DomainAccessGated = AccessGated as any as React.FC<DomainAccessControlProps>
